import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: null
  },
  mutations: {
    load: (state, data) => { state.list = data }
  },
  actions: {
    init (state) { socket.get('SportFootballActionDetail1', 'Sport/Football/Action/Detail1/load') }
  },
  getters: {
    list: state => JSON.parse(JSON.stringify(state.list)),
    get: (getters) => (id) => { return getters.list.find(item => { return item.id === id }) }
  }
}
